import { mapGetters, mapState } from 'vuex'

export default
{
	computed:
	{
		...mapState
		({
			job: state => state.jobs.job,
		}),

		...mapGetters([ 'hasJob' ]),
	},

	methods:
	{
		renderUrl(format)
		{
			return `/api/jobs/${this.job.id}/${format}`
		},
	},
}